import React, {FC} from 'react'

// import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'

import Textarea from '../Textarea'
import {ITextareaProps} from '../Textarea/Textarea'
// import s from './MobxTextArea.module.scss'
// const cx = cn.bind(s)

interface IMobxTextareaProps extends ITextareaProps {
	name: string
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	store: any
}

const MobxTextarea: FC<IMobxTextareaProps> = ({name, store, label, ...props}) => {
	const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		const newValue = e.target.value
		store[name] = newValue
	}

	return <Textarea value={store[name]} onChange={onChange} label={label} {...props} />
}

MobxTextarea.displayName = 'MobxTextarea'

export default observer(MobxTextarea)
